import { faKey, faUserAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@restart/ui/esm/Button";
import { AvForm, AvInput } from "availity-reactstrap-validation";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Label } from "reactstrap";
import { clearErrorAndSuccessful, signin } from "../redux/rootActions";
import { TranslationComponentProps } from "../types/translationComponentProps";

interface IProps extends TranslationComponentProps {
  openLogin: () => void;
  closeRegistration: () => void;
}

const Registration: React.FC<IProps> = (props: IProps) => {
  const [showDoNotMatchPassError, setShowDoNotMatchPassError] = useState(false);
  const dispatch = useDispatch();
  const { error, errorMsg, successfulLoginOrSignIn } = useSelector(
    (state: RootStateOrAny) => state.Auth,
  );

  useEffect(() => {
    dispatch(clearErrorAndSuccessful());
  }, []);

  useEffect(() => {
    if (successfulLoginOrSignIn) {
      props.closeRegistration();
    }
  }, [successfulLoginOrSignIn]);

  const handleValidSubmit = (event, values) => {
    setShowDoNotMatchPassError(false);
    if (values.password !== values.repeatedPassword) {
      setShowDoNotMatchPassError(true);
    } else {
      dispatch(signin(values.email, values.password));
    }
  };

  const backToLogin = () => {
    props.closeRegistration();
    props.openLogin();
  };

  return (
    <div className="login">
      <div className="d-flex justify-content-center pt-2 pl-3 w-100 login-header">
        <Label>{props.t("REGISTRATION.title")}</Label>
      </div>
      <AvForm onValidSubmit={handleValidSubmit}>
        <div className="d-inline-flex w-100 align-items-center login-row">
          <Button className="login-input-btn" disabled>
            <FontAwesomeIcon icon={faUserAlt} />
          </Button>
          <AvInput
            className="login-input"
            name="email"
            placeholder={props.t("REGISTRATION.email")}
            type="email"
          />
        </div>
        <div className="d-inline-flex w-100 align-items-center login-row">
          <Button className="login-input-btn" disabled>
            <FontAwesomeIcon icon={faKey} />
          </Button>
          <AvInput
            className="login-input"
            name="password"
            placeholder={props.t("REGISTRATION.password")}
            type="password"
          />
        </div>
        <div className="d-inline-flex w-100 align-items-center login-row">
          <Button className="login-input-btn" disabled>
            <FontAwesomeIcon icon={faKey} />
          </Button>
          <AvInput
            className="login-input"
            name="repeatedPassword"
            placeholder={props.t("REGISTRATION.retype_password")}
            type="password"
          />
        </div>
        <div className="d-inline-flex w-100 justify-content-center align-items-center login-submit mt-2">
          <Button className="login-button registration-button" type="submit">
            {props.t("REGISTRATION.signin")}
          </Button>
        </div>
      </AvForm>
      {(showDoNotMatchPassError || error) && (
        <div className="d-flex justify-content-center pt-1 pb-2">
          <span className="text-danger">
            {showDoNotMatchPassError
              ? props.t("REGISTRATION.do_not_match")
              : errorMsg}
          </span>
        </div>
      )}
      <div className="d-flex justify-content-center pt-1 pb-2">
        <span className="text-secondary">{props.t("LOGIN.back_to")}</span>
        <span className="forgot_pass_login" onClick={() => backToLogin()}>
          {props.t("LOGIN.login")}
        </span>
      </div>
    </div>
  );
};

export default withTranslation()(Registration);
